import { get, post, downloadFile } from './Tools';

const getByPeriodo = async (detallePeriodoId) => {
  try {
    const response = await get(`${process.env.REACT_APP_SERVER}distribucion_efectivo/detalle-periodo/${detallePeriodoId}`);
    return response;
  } catch (error) {
    console.error('Error al obtener la distribución:', error);
    return { ok: false, message: error.message };
  }
};

const calcular = async (detallePeriodoId) => {
  try {
    const response = await post(`${process.env.REACT_APP_SERVER}distribucion_efectivo/calcular/${detallePeriodoId}`);
    return response;
  } catch (error) {
    console.error('Error al calcular la distribución:', error);
    return { ok: false, message: error.message };
  }
};

const exportXlsx = async (detallePeriodoId) => {
  try {
    await downloadFile(`${process.env.REACT_APP_SERVER}distribucion_efectivo/export/xlsx/${detallePeriodoId}`);
  } catch (error) {
    console.error('Error al exportar XLSX:', error);
  }
};

const exportPdf = async (detallePeriodoId) => {
  try {
    await downloadFile(`${process.env.REACT_APP_SERVER}distribucion_efectivo/export/pdf/${detallePeriodoId}`);
  } catch (error) {
    console.error('Error al exportar PDF:', error);
  }
};

export { getByPeriodo, calcular, exportXlsx, exportPdf };